import React from 'react';

import Icon from 'components/shared/Icon';
import EmailIcon from 'components/shared/Icon/icons/Email';
import LinkIcon from 'components/shared/Icon/icons/Link';
import PhoneOutlineIcon from 'components/shared/Icon/icons/PhoneOutline';
import Text from 'components/shared/Typography/Text';

import s from './Link.module.css';
import { WysiwygLinkType } from './useLinkPortal/useLinkPortal.types';

type RadioButton = {
  type: WysiwygLinkType;
  icon: () => JSX.Element;
  labelContent: React.ReactNode;
};

export const LINK_TABS: RadioButton[] = [
  {
    type: WysiwygLinkType.url,
    icon: LinkIcon,
    labelContent: (
      <div className={s.tabLableContainer}>
        <Icon component={LinkIcon} width="2.2rem" height="2.2rem" stroke="#3f3c43" className={s.portalIcon} />
        <Text type="brandon" className={s.tabText}>
          Web URL
        </Text>
      </div>
    ),
  },
  {
    type: WysiwygLinkType.email,
    icon: EmailIcon,
    labelContent: (
      <div className={s.tabLableContainer}>
        <Icon component={EmailIcon} width="2.2rem" height="2.2rem" stroke="#3f3c43" className={s.portalIcon} />
        <Text type="brandon" className={s.tabText}>
          Email
        </Text>
      </div>
    ),
  },
  {
    type: WysiwygLinkType.tel,
    icon: PhoneOutlineIcon,
    labelContent: (
      <div className={s.tabLableContainer}>
        <Icon
          component={PhoneOutlineIcon}
          width="2.2rem"
          height="2.2rem"
          stroke="#3f3c43"
          fill="none"
          className={s.portalIcon}
        />
        <Text type="brandon" className={s.tabText}>
          Phone
        </Text>
      </div>
    ),
  },
];
